import { useState } from "react";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";

const Queries = ({
  query,
  replies = [],
  onReply,
  setParentId,
  setIsSubQuery,
  fetchReplies,
}) => {
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const [showReplies, setShowReplies] = useState(false);
  const [childReplies, setChildReplies] = useState([]);
  const handleToggleReplies = () => {
    setShowReplies(!showReplies);

    if (!showReplies && parseInt(query.child_comment_count) > 0) {
      fetchReplies(query.id);
    }
  };

  return (
    <div className="media d-flex border-bottom border-light mb-3 pb-3">
      <div className="media-body flex-shrink-1 w-100">
        <div className="row justify-content-between">
          <div className="col-md">
            <h6 className="mt-0 fw-medium mb-0">
              {query.employeeName} FeedBack to{" "}
              {`${query?.receiver_firstName} ${query?.receiver_lastName}`}
            </h6>
            <p className="text-muted text-dark m-0 text-xs">
              {new Date(query.timestamp).toLocaleString()}
            </p>
          </div>
          {/* <div className="col-md-auto">
            {query?.sender_id == userProfile?.employeeId && (
              <>
                {" "}
                <button
                  className="btn btn-sm btn-outline-secondary me-2"
                  //   onClick={() => onEdit?.(query)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  //   onClick={() => onDelete?.(query)}
                >
                  Delete
                </button>
              </>
            )}
          </div> */}
        </div>

        <div className="query-text mt-3">
          <p>{query.message}</p>
        </div>

        <div>
          {query?.receiver_id == userProfile?.employeeId && (
            <button
              className="btn btn-link p-0 text-decoration-none"
              onClick={() => onReply?.(query)}
            >
              Reply
            </button>
          )}

          {query?.receiver_id == userProfile?.employeeId &&
            parseInt(query.child_comment_count || 0) > 0 && (
              <span className="text-muted mx-1">|</span>
            )}

          {parseInt(query.child_comment_count || 0) > 0 && (
            <button
              type="button"
              className="btn btn-link text-capitalize p-0 text-decoration-none text-danger"
              onClick={handleToggleReplies}
            >
              {query.child_comment_count}{" "}
              {query.child_comment_count > 1 ? "FeedBacks" : "FeedBack"}
            </button>
          )}
        </div>

        {showReplies && (
          <ul className="mt-3 ps-4">
            {replies.map((reply) => (
              <Queries
                key={reply.id}
                query={reply}
                replies={reply.replies}
                onReply={onReply}
                fetchReplies={fetchReplies}
              />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Queries;
